import React, { useState } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { observer } from "mobx-react";
import authStore from "../stores/AuthStore";
import UserProfile from "../component/setting-components/UserProfile";
import OptionComponent from "../component/setting-components/Option";
import TeamSettings from "../component/setting-components/TeamDetail";

const SettingPage = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();

  const initialTab = searchParams.get("tab") || "profile";
  const [activeTab, setActiveTab] = useState(initialTab);

  const currentUser = authStore.getUser();
  console.log("User in setting: ", currentUser);

  const handleTabClick = (tabValue) => {
    setActiveTab(tabValue);
    setSearchParams({ tab: tabValue });
  };

  return (
    <>
      <Box className="mb-6">
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Settings
        </Typography>
      </Box>

      {/* Tab Buttons */}
      <Box className="flex gap-4 mb-6">
        {[
          { label: "My Profile", value: "profile" },
          { label: "Options", value: "options" },
          { label: "Team", value: "team" },
          { label: "Plan", value: "plan" },
          { label: "Billing", value: "billing" },
          { label: "Email", value: "email" },
          { label: "Integration", value: "integration" },
          { label: "API", value: "api" },
        ].map((tab) => (
          <Box
            key={tab.value}
            sx={{
              borderBottom: "2px solid",
              borderColor:
                activeTab === tab.value
                  ? theme.palette.mode === "dark"
                    ? "#BD93F9"
                    : "#22C55E"
                  : "transparent",
              "&:hover":
                theme.palette.mode === "dark" ? { borderColor: "#D6A8FF" } : {},
            }}
          >
            <Button
              onClick={() => handleTabClick(tab.value)}
              sx={{
                textTransform: "none",
                fontSize: "0.9rem",
                color:
                  activeTab === tab.value
                    ? theme.palette.mode === "dark"
                      ? "#BD93F9"
                      : "#000000"
                    : "text.primary",
                transition: "color 0.2s ease-in-out",
                "&:hover":
                  theme.palette.mode === "dark"
                    ? { color: theme.palette.primary.light }
                    : {},
              }}
            >
              {tab.label}
            </Button>
          </Box>
        ))}
      </Box>

      {/* Content Area */}
      {activeTab === "profile" ? (
        <UserProfile userID={currentUser.userID} />
      ) : activeTab === "options" ? (
        <OptionComponent />
      ) : activeTab === "team" ? (
        <TeamSettings />
      ) : (
        <Box className="flex justify-center min-h-[60vh]">
          <Typography variant="body1">{activeTab} Content</Typography>
        </Box>
      )}
    </>
  );
});

export default SettingPage;
